module.exports = __webpack_public_path__ + "static/img/アセット 38@2x.3be7adf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 38@2x.png
// module id = msio
// module chunks = 1